<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- <button @click="printLog">输出</button> -->
    <!-- <skeleton/> -->
    <te :data="[{label: '1', key: 1}, {label: 2, key: 2}]"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import skeleton from '@/components/base/skeleton.vue'
import te from './t';

export default {
  name: 'Home',
  components: {
    HelloWorld,
    skeleton,
    te
  },
  methods: {
    printLog() {
      console.log(process.env.VUEAPI);
      console.log(process.env.VUE_APP_EVN);
      console.log(process.env.VUE_APP_API);
      console.log(process.env.VUE_APP_HOST);
      console.log(process.env.VUE_APP_HRAPI);
      console.log(process.env.VUE_APP_AUTH);
    }
  },
}
</script>
